<div [class.is-invalid]="wrongPin">
	<input
		#passwordInput
		type="password"
		disabled
		class="input"
		value="{{ pin }}"
		[placeholder]="placeholderText"
		[class.is-invalid]="wrongPin"
	/>
	<app-custom-keyboard
		#pinKeyboard
		[template]="keyboardTemplate"
		(typedValue)="typedText($event)"
	></app-custom-keyboard>
</div>
